module.exports = __webpack_public_path__ + "media/components/slider/s1-03b4f445f0b7c4ad5c2843a722917647.jpg";